(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9115],{

/***/ 59548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17155);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19604);
/* harmony import */ var _mui_icons_material_ContentCopyTwoTone__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71815);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5786);
/* eslint-disable react/prop-types */ 





function CopyChat(param) {
    var stringToCopy = param.stringToCopy;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var handleClick = function() {
        setOpen(true);
        navigator.clipboard.writeText(stringToCopy);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onClick: handleClick,
                color: "primary",
                style: {
                    padding: "1px",
                    marginLeft: "4px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ContentCopyTwoTone__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        color: _tokens__WEBPACK_IMPORTED_MODULE_2__/* .tokens.token_surface */ .T.token_surface,
                        height: "18px",
                        width: "18px"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                autoHideDuration: 800,
                onClose: function() {
                    return setOpen(false);
                },
                open: open,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    severity: "info",
                    children: "Copied to clipboard!"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CopyChat);


/***/ }),

/***/ 4019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79072);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13264);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);
/* eslint-disable no-unused-vars */ 






function Copyright() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            " \xa9 ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "./about/blockquiry",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: "small",
                    sx: {
                        textTransform: "none",
                        bgcolor: "none"
                    },
                    children: [
                        "blockquiry ",
                        new Date().getFullYear(),
                        "."
                    ]
                })
            }),
            " "
        ]
    });
}
var Item = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        px: 2,
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_typography_regular */ .T.token_typography_regular,
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.775rem",
        fontWeight: 500,
        whiteSpace: "nowrap"
    };
});
var StyledLink = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_2___default()))(function() {
    return {
        // px: 2,
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_typography_regular */ .T.token_typography_regular,
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.775rem",
        fontWeight: 500,
        whiteSpace: "nowrap"
    };
});
function Footer() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        component: "footer",
        position: "fixed",
        bottom: 0,
        width: "100%",
        sx: {
            backgroundColor: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            justifyContent: "space-between",
            alignItems: "center",
            px: 5,
            py: 0.25,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        container: true,
                        justifyContent: {
                            xs: "center",
                            sm: "center",
                            md: "flex-start"
                        },
                        spacing: 1,
                        sx: {
                            display: {
                                xs: "none",
                                md: "flex"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/web/blockquiry/searx",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        size: "small",
                                        sx: {
                                            textTransform: "none",
                                            bgcolor: "none"
                                        },
                                        children: "web"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/tor/blockquiry",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        size: "small",
                                        sx: {
                                            textTransform: "none",
                                            bgcolor: "none"
                                        },
                                        children: "tor"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        textAlign: {
                            xs: "center",
                            sm: "center",
                            md: "center"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Copyright, {})
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        container: true,
                        justifyContent: {
                            xs: "center",
                            sm: "center",
                            md: "flex-end"
                        },
                        spacing: 1,
                        sx: {
                            display: {
                                xs: "none",
                                md: "flex"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/about/blockquiry/privacy",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        size: "small",
                                        sx: {
                                            textTransform: "none",
                                            bgcolor: "none"
                                        },
                                        children: "Privacy"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/about/blockquiry/terms",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        size: "small",
                                        sx: {
                                            textTransform: "none",
                                            bgcolor: "none"
                                        },
                                        children: "Terms"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 18609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ChatHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./src/tokens.js
var src_tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./src/components/homepage/app-menu/AppMenu.js + 1 modules
var AppMenu = __webpack_require__(41768);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIosOutlined.js
var ArrowBackIosOutlined = __webpack_require__(93230);
// EXTERNAL MODULE: ./src/components/layouts/searchlayout/utils/MonetizationButton.js + 1 modules
var MonetizationButton = __webpack_require__(4917);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@mui/base/Button/buttonClasses.js
var buttonClasses = __webpack_require__(16079);
// EXTERNAL MODULE: ./node_modules/@mui/base/Tabs/Tabs.js + 3 modules
var Tabs = __webpack_require__(92565);
// EXTERNAL MODULE: ./node_modules/@mui/base/Tab/Tab.js + 5 modules
var Tab = __webpack_require__(3017);
// EXTERNAL MODULE: ./node_modules/@mui/base/Tab/tabClasses.js
var tabClasses = __webpack_require__(55334);
// EXTERNAL MODULE: ./node_modules/@mui/base/TabsList/TabsList.js + 13 modules
var TabsList = __webpack_require__(57106);
;// CONCATENATED MODULE: ./src/components/blockquiry-chat/components/ModelTabs.js
/* eslint-disable no-unused-vars */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Roboto, Arial, sans-serif;\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 0.775rem;\n  font-weight: 500;\n  background-color: transparent;\n  width: auto;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-right: 8px;\n  padding-left: 8px;\n  margin: 4px 4px;\n  border: none;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  border-radius: 24px;\n  border: 1px solid ",
        ";\n\n  justify-content: center;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:focus {\n    color: ",
        ";\n    outline: 1px solid ",
        ";\n  }\n\n  &.",
        " {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.",
        " {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledTab = (0,styled/* default */.Z)(Tab/* default */.Z)(_templateObject(), src_tokens/* tokens.token_text_grey_on_grey */.T.token_text_grey_on_grey, src_tokens/* tokens.token_table_background */.T.token_table_background, src_tokens/* tokens.token_surface */.T.token_surface, src_tokens/* tokens.token_red */.T.token_red, src_tokens/* tokens.token_table_bottom_border */.T.token_table_bottom_border, tabClasses/* default.selected */.Z.selected, src_tokens/* tokens.token_grey_100 */.T.token_grey_100, src_tokens/* tokens.token_grey_900 */.T.token_grey_900, buttonClasses/* default.disabled */.Z.disabled);
var StyledTabsList = (0,styled/* default */.Z)(TabsList/* default */.Z)(function(param) {
    var theme = param.theme;
    return "\n  min-width: 400px;\n  background-color: ".concat(src_tokens/* tokens.token_surface */.T.token_surface, ";\n  border: transparent;\n  border-radius: 4px;\n  margin-bottom: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: space-between;\n          \n  ");
});
function ModelTabs(param) {
    var setSelectedAPIRoute = param.setSelectedAPIRoute;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            maxWidth: "100%",
            my: 0.5,
            overflow: "hidden",
            overflowX: "scroll",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
                display: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
            defaultValue: 0,
            "aria-label": "Tabs where selection follows focus",
            selectionFollowsFocus: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabsList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                        children: "General QA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                        disabled: true,
                        children: "Incident Report"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                        disabled: true,
                        children: "Fraud Detection"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                        disabled: true,
                        children: "Data Analytics"
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/blockquiry-chat/components/ChatHeader.js
/* eslint-disable no-empty-pattern */ 








// import ReportDialog from '../../accountdetails/reportcryptocrime/ReportDialog';




function ColorText(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("span", {
        style: {
            color: tokens.palette_secondary
        },
        children: children
    });
}
var BlockTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "play",
        opacity: 1,
        fontSize: "1.50rem",
        fontWeight: 700,
        lineHeight: "1.5rem",
        textAlign: "center",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: src_tokens/* tokens.palette_secondary */.T.palette_secondary,
        cursor: "pointer"
    };
});
var TitleTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        textTransform: "none",
        // fontFamily: 'Roboto,arial,sans-serif',
        fontFamily: "play",
        opacity: 1,
        display: "inline-block",
        fontStretch: "100%",
        fontSize: "1.50rem",
        fontWeight: 500,
        textSizeAdjust: "100%",
        cursor: "pointer",
        lineHeight: "1.75rem",
        letterSpacing: "normal",
        textAlign: "left",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        marginLeft: "4px",
        color: src_tokens/* tokens.palette_primary */.T.palette_primary
    };
});
var StyledToolbar = (0,styled/* default */.Z)(Toolbar/* default */.Z)(function() {
    return {
        alignItems: "flex-start",
        paddingTop: "16px",
        paddingBottom: "4px",
        paddingRight: "16px",
        paddingLeft: "8px",
        // Override media queries injected by theme.mixins.toolbar
        "@media all": {
            minHeight: 70
        }
    };
});
function ChatHeader(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    // console.log('Inside ChatHeader.js', setSelectedAPIRoute);
    var router = (0,next_router.useRouter)();
    var handleClick = function() {
        console.log("MonetizationButton clicked");
    // add other functionality
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            flexGrow: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
            position: "static",
            elevation: 0,
            sx: {
                position: "relative",
                //   borderBottom: (t) => `1px solid ${t.palette.divider}`,
                borderBottom: "1px solid ".concat(src_tokens/* tokens.token_search_border_grey */.T.token_search_border_grey),
                backgroundColor: {
                    xs: src_tokens/* tokens.token_surface */.T.token_surface,
                    sm: src_tokens/* tokens.token_surface */.T.token_surface,
                    md: src_tokens/* tokens.token_surface */.T.token_surface
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledToolbar, {
                    variant: "dense",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            sx: {},
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "rounded",
                                sx: {
                                    bgcolor: "transparent",
                                    display: {
                                        xs: "block",
                                        sm: "block",
                                        md: "none"
                                    },
                                    // border: '1px solid',
                                    // borderColor: tokens.token_grey_300,
                                    width: "28px",
                                    height: "28px",
                                    marginRight: "4px",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIosOutlined/* default */.Z, {
                                    sx: {
                                        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
                                        // width: '26px',
                                        // height: '26px',
                                        fontSize: "1.50rem",
                                        paddingTop: "0.25rem",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            sx: {},
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "rounded",
                                sx: {
                                    bgcolor: "transparent",
                                    border: "1px solid",
                                    borderColor: src_tokens/* tokens.token_grey_300 */.T.token_grey_300,
                                    width: "28px",
                                    height: "28px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTypo, {
                                    children: "b"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypo, {
                            sx: {},
                            children: "chat"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                minWidth: "60px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenu/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                minWidth: "60px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MonetizationButton/* default */.Z, {
                                router: router,
                                onClick: handleClick
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                    variant: "dense",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelTabs, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            flexGrow: 1
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 41768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_menu_AppMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(73812);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 28 modules
var makeStyles = __webpack_require__(77338);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Apps.js
var Apps = __webpack_require__(94492);
// EXTERNAL MODULE: ./src/tokens.js
var tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./src/components/layouts/searchlayout/utils/ChatButton.js
var ChatButton = __webpack_require__(36067);
// EXTERNAL MODULE: ./src/components/layouts/searchlayout/utils/MessageButton.js
var MessageButton = __webpack_require__(95162);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OutlinedFlag.js
var OutlinedFlag = __webpack_require__(26981);
;// CONCATENATED MODULE: ./src/components/layouts/searchlayout/utils/ReportButton.js







var IconText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: tokens/* tokens.palette_primary */.T.palette_primary
    };
});
var StyledIcon = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        marginBottom: "4px",
        height: "18px",
        width: "18px",
        color: tokens/* tokens.token_red_typography */.T.token_red_typography,
        "&:hover": {
            color: tokens/* tokens.palette_secondary */.T.palette_secondary
        }
    };
});
var TriggerButton = (0,styled/* default */.Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(tokens/* tokens.token_grey_100 */.T.token_grey_100, ";\n  &:hover {\n    background: ").concat(tokens/* tokens.token_grey_10 */.T.token_grey_10, ";\n    border-color: ").concat(tokens/* tokens.token_grey_300 */.T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(tokens/* tokens.token_blue_500 */.T.token_blue_500, ";\n    outline: 3px solid ").concat(tokens/* tokens.token_blue_200 */.T.token_blue_200, ";\n  }\n  ");
});
function ReportButton_MessageButton() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TriggerButton, {
            disabled: true,
            "aria-label": "message",
            onClick: function() {
                return router.push("/blockquiry_connect/u/select_agency");
            },
            sx: {
                "&:hover": {
                    color: tokens/* tokens.palette_secondary */.T.palette_secondary
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedFlag/* default */.Z, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconText, {
                        variant: "caption",
                        children: "Report"
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/homepage/app-menu/AppMenu.js








// import ReportDialog from '../../accountdetails/reportcryptocrime/ReportDialog';



var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        iconButton: {
            padding: theme.spacing(0.5)
        },
        icon: {
            marginBottom: theme.spacing(0.5)
        }
    };
});
var AppMenu_IconText = (0,styled/* default */.Z)("div")({
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: "0.675rem",
    letterSpacing: "0.0107142857em",
    fontWeight: 500,
    color: tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
    lineHeight: "0.875rem",
    display: "flex",
    justifyContent: "center"
});
function AppMenu() {
    var router = (0,next_router.useRouter)();
    var ref = (0,next_router.useRouter)(), push = ref.push, asPath = ref.asPath;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var classes = useStyles();
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                // disabled
                "aria-controls": "menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                sx: {
                    color: tokens/* tokens.palette_primary */.T.palette_primary,
                    margin: "4px",
                    "&.MuiButtonBase-root.MuiIconButton-root:hover": {
                        borderRadius: "8px",
                        padding: "8px",
                        backgroundColor: tokens/* tokens.token_hairline */.T.token_hairline
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apps/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                id: "menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        // my: { xs: '4px', md: '4px' },
                        // mx: { xs: '4px', md: '4px' },
                        p: {
                            xs: "4px",
                            md: "4px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        direction: "row",
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatButton/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportButton_MessageButton, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageButton/* default */.Z, {})
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var app_menu_AppMenu = (AppMenu);


/***/ }),

/***/ 36067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChatButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9144);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var _mui_icons_material_MarkChatReadOutlined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47695);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);







var IconText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
    };
});
var StyledIcon = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        marginBottom: "4px",
        height: "18px",
        width: "18px",
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        "&:hover": {
            color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
        }
    };
});
var TriggerButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100, ";\n  &:hover {\n    background: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_10 */ .T.token_grey_10, ";\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_500 */ .T.token_blue_500, ";\n    outline: 3px solid ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_200 */ .T.token_blue_200, ";\n  }\n  ");
});
function ChatButton() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TriggerButton, {
            // disabled
            "aria-label": "b_chat",
            onClick: function() {
                return router.push("/blockquiry_chat");
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_MarkChatReadOutlined__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            fontSize: "small",
                            sx: {
                                color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconText, {
                        variant: "caption",
                        children: "ChatBot"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 95162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MessageButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9144);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var _mui_icons_material_ThreePOutlined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84512);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);







var IconText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
    };
});
var StyledIcon = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        marginBottom: "4px",
        height: "18px",
        width: "18px",
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        "&:hover": {
            color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
        }
    };
});
var TriggerButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100, ";\n  &:hover {\n    background: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_10 */ .T.token_grey_10, ";\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_500 */ .T.token_blue_500, ";\n    outline: 3px solid ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_200 */ .T.token_blue_200, ";\n  }\n  ");
});
function MessageButton() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TriggerButton, {
            disabled: true,
            "aria-label": "message",
            onClick: function() {
                return router.push("/blockquiry_connect/u/select_agency");
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ThreePOutlined__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconText, {
                        variant: "caption",
                        children: "Messages"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 4917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MonetizationButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(32046);
;// CONCATENATED MODULE: ./src/components/layouts/searchlayout/utils/LightTooltip.js
/* eslint-disable import/no-relative-packages */ 






var LightTooltip = (0,styled/* default */.ZP)(function(props) {
    var className = props.className, otherProps = (0,_object_without_properties/* default */.Z)(props, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11
    });
});
/* harmony default export */ var utils_LightTooltip = (LightTooltip);

// EXTERNAL MODULE: ./src/tokens.js
var tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PowerSettingsNewOutlined.js
var PowerSettingsNewOutlined = __webpack_require__(74808);
;// CONCATENATED MODULE: ./src/components/layouts/searchlayout/utils/MonetizationButton.js










function MonetizationButton(param) {
    var router = param.router, onClick = param.onClick;
    var ref = (0,react.useState)(false), clicked = ref[0], setClicked = ref[1];
    var handleClick = function() {
        setClicked(!clicked);
        // add micro payment function  when the button is clicked
        if (onClick) {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_LightTooltip, {
        title: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                //   disabled
                "aria-label": "money-button",
                onClick: handleClick,
                sx: {
                    margin: "4px",
                    "&.MuiButtonBase-root.MuiIconButton-root:hover": {
                        borderRadius: "8px",
                        padding: "8px",
                        backgroundColor: tokens/* tokens.token_hairline */.T.token_hairline
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "rounded",
                    sx: {
                        bgcolor: "transparent",
                        border: "1px solid",
                        borderColor: clicked ? tokens/* tokens.token_green_600 */.T.token_green_600 : tokens/* tokens.token_grey_300 */.T.token_grey_300,
                        width: "24px",
                        height: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PowerSettingsNewOutlined/* default */.Z, {
                        sx: {
                            color: clicked ? tokens/* tokens.token_green_600 */.T.token_green_600 : tokens/* tokens.token_grey_300 */.T.token_grey_300,
                            width: "20px",
                            height: "20px"
                        }
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 14569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81719);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17575);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32046);
// eslint-disable-next-line import/first
/* eslint-disable import/no-relative-packages */ 






var LightTooltip = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(props) {
    var className = props.className, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, otherProps), {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"].tooltip */ .Z.tooltip), {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (LightTooltip);


/***/ }),

/***/ 59740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Test_main__2xw9L","header":"Test_header__GiCOT","topnav":"Test_topnav__gRK9k","navlogo":"Test_navlogo__zTdrf","navlinks":"Test_navlinks__93hfi","apptitle":"Test_apptitle__MjyKv","appdescription":"Test_appdescription__tJ3ao","link":"Test_link__ZMMnx","cloudform":"Test_cloudform__dsEDA","textarea":"Test_textarea__sgXIH","generatebutton":"Test_generatebutton__D64MJ","loadingwheel":"Test_loadingwheel__3D_rL","svgicon":"Test_svgicon__GE1rk","messagelist":"Test_messagelist__ZhdFW","messagelistloading":"Test_messagelistloading__NoIEk","usermessage":"Test_usermessage__38_gn","usermessagewaiting":"Test_usermessagewaiting__D7UO0","loading-gradient":"Test_loading-gradient__E_GwR","apimessage":"Test_apimessage__7dyyG","fadein":"Test_fadein__HQ8GO","markdownanswer":"Test_markdownanswer__iqemk","boticon":"Test_boticon__a_yP2","usericon":"Test_usericon__BZTHc","center":"Test_center___yT47","cloud":"Test_cloud__BHCe3","pointsnormal":"Test_pointsnormal__1Hy3e","pointsdim":"Test_pointsdim__Pm27b","footer":"Test_footer__173qM"};

/***/ })

}]);